import React, { useMemo, useState, useEffect } from 'react';
import { TopWaitingDrivers } from '../components/dashboard/TopWaitingDrivers';

import { CancellationReasons } from '../components/dashboard/CancellationReasons';
import { StuckStatus } from '../components/dashboard/StuckStatus';
import { DepositoPerformance } from '../components/dashboard/DepositoPerformance';
import { KPICards } from '../components/dashboard/KPICards';
import { Container, Box, Typography, Grid } from '@mui/material';
import {
  mockCheckinData,
  mockDepositos,
  calculateCancellationReasons,
  calculateStuckStatus,
  calculateDepositoPerformance,
} from '../utils/mock';

import { calculateDriverWaits } from '../utils/calculateDriverWaits';
import Unauthorized from '../components/Unauthorized'; // <-- importar


export default function Dashboard() {
  const cancellationReasons = useMemo(() => calculateCancellationReasons(mockCheckinData), []);
  const stuckStatuses = useMemo(() => calculateStuckStatus(mockCheckinData), []);
  const depositoPerformances = useMemo(() => calculateDepositoPerformance(mockCheckinData, mockDepositos), []);

  const totalCheckins = mockCheckinData.length;
  const totalCancelados = mockCheckinData.filter(r => r.status === 'Cancelado').length;
  const totalFinalizados = mockCheckinData.filter(r => r.status === 'Finalizado').length;
  const emFila = mockCheckinData.filter(r => r.status === 'Em Fila').length;
  const waitingDrivers = useMemo(() => calculateDriverWaits(mockCheckinData), []);
  const [roleName, setRoleName] = useState < string > ('');

  useEffect(() => {
    // retirar do localStorage e extrair role_name (com fallback pra role.name)
    const storedUser = localStorage.getItem('user');
    let roleNameLocal = '';
    if (storedUser) {
      try {
        const parsed = JSON.parse(storedUser);
        roleNameLocal = parsed.role_name ?? parsed.role?.name ?? '';
      } catch (e) {
        console.error('Erro ao parsear user:', e);
      }
    }

    // normalizar e checar se contém a parte "driver"
    const normalized = roleNameLocal.trim().toLowerCase();

    // atualizar states
    setRoleName(normalized);
  }, []);

  // Se o usuário não for admin, mostrar Unauthorized
  if (roleName !== 'admin') {
    return <Unauthorized />;
  }

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'grey.50' }}>
      {/* Header */}
      <Box sx={{
        minHeight: '15vh',
        background: 'linear-gradient(135deg, #004792 0%, #38A845 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        <Container maxWidth="lg">
          <Typography variant="h4" fontWeight="bold" gutterBottom color="white">
            Dashboard Executivo
          </Typography>
          <Typography variant="subtitle1" color="white">
            Análise de Check-in de Motoristas e Performance de Depósitos
          </Typography>
        </Container>
      </Box>

      <Container maxWidth="lg" sx={{ mt: 5 }}>
        {/* KPI Cards */}
        <KPICards
          totalCheckins={totalCheckins}
          totalFinalizados={totalFinalizados}
          totalCancelados={totalCancelados}
          emFila={emFila}
        />


        <TopWaitingDrivers drivers={waitingDrivers} sx={{ flexGrow: 1, mt: 5 }} />

        {/* Conteúdo principal em 2 colunas */}
        <Grid
          container
          spacing={4}
          sx={{
            display: 'flex',
            alignItems: 'stretch',
            gap: 4,
            mt: -4,
          }}
        >
          {/* Coluna esquerda */}
          <Grid
            size={{ xs: 12, md: 6 }}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              flexGrow: 1,
            }}
          >

            { /*<TopWaitingDriversChart drivers={waitingDrivers} sx={{ flexGrow: 1 }} />*/}
            <CancellationReasons reasons={cancellationReasons} sx={{ flexGrow: 1 }} />
            <StuckStatus data={stuckStatuses} sx={{ flexGrow: 1, mt: 5 }} />
          </Grid>

          {/* Coluna direita */}
          <Grid
            size={{ xs: 12, md: 6 }}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              flexGrow: 1,
            }}
          >
            <DepositoPerformance depositos={depositoPerformances} sx={{ flexGrow: 1 }} />
          </Grid>
        </Grid>





      </Container>

      {/* Footer */}
      <Box sx={{ mt: 12, py: 4, bgcolor: 'grey.900', color: 'grey.400', textAlign: 'center' }}>
        <Typography variant="body2">© 2025 Director Dashboard. Todos os direitos reservados.</Typography>
      </Box>
    </Box>
  );
}
